import safeLocalStorage from 'pricing-pages-ui-components/utils/safeLocalStorage';
import { BROWSER_LOCALE_KEY, COUNTRY_CODE_KEY, FF_OVERRIDES_KEY, I18N_LANG_KEY, getFeatureFlagOverrides } from 'pricing-pages-ui-components/utils/debugOverrides';
export { FF_OVERRIDES_KEY, COUNTRY_CODE_KEY, BROWSER_LOCALE_KEY, I18N_LANG_KEY, getFeatureFlagOverrides, applyFeatureFlagOverrides, getCountryCodeOverride, getBrowserLocaleOverride, getI18nLangOverride, getActiveOverrideCount } from 'pricing-pages-ui-components/utils/debugOverrides';
export function setFeatureFlagOverride(flag, value) {
  const current = getFeatureFlagOverrides();
  if (value === null) {
    delete current[flag];
  } else {
    current[flag] = value;
  }
  if (Object.keys(current).length === 0) {
    safeLocalStorage.removeItem(FF_OVERRIDES_KEY);
  } else {
    safeLocalStorage.setItem(FF_OVERRIDES_KEY, JSON.stringify(current));
  }
}
export function setCountryCodeOverride(code) {
  if (code) {
    safeLocalStorage.setItem(COUNTRY_CODE_KEY, code.toUpperCase());
  } else {
    safeLocalStorage.removeItem(COUNTRY_CODE_KEY);
  }
}
export function setBrowserLocaleOverride(locale) {
  if (locale) {
    safeLocalStorage.setItem(BROWSER_LOCALE_KEY, locale);
  } else {
    safeLocalStorage.removeItem(BROWSER_LOCALE_KEY);
  }
}
export function setI18nLangOverride(lang) {
  if (lang) {
    safeLocalStorage.setItem(I18N_LANG_KEY, lang);
  } else {
    safeLocalStorage.removeItem(I18N_LANG_KEY);
  }
}
export function clearAllOverrides() {
  safeLocalStorage.removeItem(FF_OVERRIDES_KEY);
  safeLocalStorage.removeItem(COUNTRY_CODE_KEY);
  safeLocalStorage.removeItem(BROWSER_LOCALE_KEY);
  safeLocalStorage.removeItem(I18N_LANG_KEY);
}